'use client'
import NestError from "@/app/components/nesterror"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div>
          <NestError error={{ statusCode: 500, message: "Please try again after some time!" }} />
          
          <div style={{ 
            padding: '1rem', 
            margin: '1rem auto', 
            maxWidth: '500px',
            backgroundColor: '#e3f2fd', 
            border: '1px solid #2196f3',
            borderRadius: '4px',
            textAlign: 'center'
          }}>
            <h3>✅ Phase 4: 500 Error Page Migrated</h3>
            <p>App Router global-error.tsx using NestError component</p>
            <button
              onClick={reset}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '1rem'
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}